import React from "react";
import { Link } from "react-router-dom";
import { LogoLockup } from "./Logo";
import { PRODUCTS, INDUSTRIES } from "../data/products";
import { RESOURCES } from "../data/resources";

function FooterCol({ title, items, testid }) {
  return (
    <div className="footer-col" data-testid={`footer-col-${testid}`}>
      <div className="footer-col-title">{title}</div>
      <ul>
        {items.map((it, i) => (
          <li key={i}>
            {it.to ? <Link to={it.to}>{it.label}</Link> : <a href={it.href}>{it.label}</a>}
          </li>
        ))}
      </ul>
    </div>
  );
}

export function Footer() {
  return (
    <footer className="footer" id="footer" data-testid="main-footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <LogoLockup />
            <p className="footer-tag">Where capital meets cognition.</p>
            <div className="footer-addr">
              Unit No 603-604, 6th Floor, Tower B<br />
              Bhutani Alphathum, Nepz Post Office<br />
              Gautam Buddha Nagar, Noida, UP 201305, India
            </div>
          </div>
          <div className="footer-cols">
            <FooterCol
              title="Platforms"
              testid="platforms"
              items={PRODUCTS.map((p) => ({ label: `${p.indo} — ${p.name}`, to: `/platforms/${p.slug}` }))}
            />
            <FooterCol
              title="Industries"
              testid="industries"
              items={INDUSTRIES.map((i) => ({ label: i.name, to: "/industries" }))}
            />
            <FooterCol
              title="Resources"
              testid="resources"
              items={RESOURCES.slice(0, 5).map((r) => ({ label: r.title, to: "/resources" }))}
            />
            <FooterCol
              title="Company"
              testid="company"
              items={[
                { label: "About", to: "/about" },
                { label: "Contact", to: "/contact" },
                { label: "Trust Center", to: "/trust" },
                { label: "Privacy", to: "/privacy" },
                { label: "Cookie Notice", to: "/cookies" },
              ]}
            />
          </div>
        </div>
        <div className="footer-bottom">
          <div>© 2026 Capexara AI · Made in Bharat</div>
          <button
            type="button"
            className="footer-cookie-btn"
            onClick={() => window.dispatchEvent(new CustomEvent("capexara:open-cookie-prefs"))}
            data-testid="footer-cookie-prefs-btn"
          >
            Cookie preferences
          </button>
        </div>
      </div>
    </footer>
  );
}
